export const environment = {
    production: true,
    apiUrl: 'https://api.constantcaretechnology.com',
    baseUrl: 'https://app02.constantcaretechnology.com',
    client_id: 'zChobG0BKq2gA2SSpGAP4RA6lEmALrf6'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts